// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode{margin:40px auto 30px;width:280px;height:280px}", ""]);
// Exports
module.exports = exports;
